export default __webpack_public_path__ + "static/media/rider.42d5b394.svg";